import React from 'react'

export interface Props {
    className?: string
}

export const IconLightning: React.FC<Props> = props => (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor" fillRule="evenodd">
            <path d="M3.86 0h8.003L10.46 6.705 0 14.118z" />
            <path d="M2.218 6h14.817l-3.673 8.14H0z" />
            <path d="M7 10.951L17.03 6 8.452 27.558z" />
        </g>
    </svg>
)
